import React, {useReducer} from 'react'
import {ModalContext} from './ModalContext'
import {MODAL_ACTION} from "../../constant"

const initialModal = {
	about: false,
	feedback: false,
	feedbackPersonal: false,
	settings: false,
	settingsSuccess: false,
	login: false,
	registration: false,
	registrationSuccess: false,
	sendAnnounces: false,
	sendAnnouncesSuccess: false,
	sessionActive: false,
	error: false,
	params: {

	}
};

const modalReducer = (state, action) => {
	switch (action.type){
		case MODAL_ACTION.OPEN: {
			return {
				...state,
				[action.payload]: true,
			}
		}
		case MODAL_ACTION.CLOSE: {
			return initialModal
		}
		case MODAL_ACTION.MODAL_TOGGLE: {
			return {
				...state,
				...action.payload
			}
		}
		case MODAL_ACTION.SET_PARAMS: {
			return {
				...state,
				...{params: action.payload}
			}
		}
		default: {
			return state
		}
	}
}


export function ModalProvider({children}){
	const [modal, dispatch] = useReducer(modalReducer, initialModal)

	return <ModalContext.Provider value={{
				modal,
				openModal: (name) => dispatch({type: MODAL_ACTION.OPEN, payload: name}),
				closeModal: (name) => dispatch({type: MODAL_ACTION.CLOSE, payload: name}),
				toggleModal: (params) => dispatch({type: MODAL_ACTION.MODAL_TOGGLE, payload: params}),
				setModalParams: (params) => dispatch({type: MODAL_ACTION.SET_PARAMS, payload: params}),
			}}>
				{children}
			</ModalContext.Provider>
}